/**
 * Created by 汤振兴 on 2017/2/18.
 */

import Vue from 'vue'
import Router from 'vue-router'
import store from 'src/store'
import routes from './routes'

Vue.use(Router)

let oRouter = new Router({
    base: '/wb/',
    mode: 'history',
    routes: routes
})

// 和axios拦截器不冲突
oRouter.beforeEach((to, from, next) => {
    let { auth = true } = to.meta
    let isLogin = !!store.state.user.id
    // 登录状态判断
    if (auth && !isLogin) {
        return next({
            name: 'login',
            query: {
                from: to.fullPath
            }
        })
    }
    next()
})

oRouter.afterEach(to => {
    let path = (to.path || '').replace(/^\//, '')
    document.body.setAttribute('data-root', path.split('/').join('-'))
})

oRouter.afterEach((to, from) => {
    // window.neteaseTracker(true, location.href)
})

export default oRouter


// WEBPACK FOOTER //
// ./src/router/index.js